import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Hero from "../components/technlogoy/hero.js";
import Tech from "../components/technlogoy/tech.js";
import Partners from "../components/universal/partners.js";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Our Technology | Regent Dental</title>
        <meta
          name="description"
          content="Discover the latest dental technology at Regent Dental West Yorkshire. From digital X-rays to 3D imaging, we deliver accurate, comfortable, and efficient care."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/our-technology"
        />
      </Helmet>
      <Navbar />
      <Hero />
      <Tech />
      <Partners />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
